import { observer } from 'mobx-react-lite';
import React from 'react';
import { useAddresses } from '../../../../http/addressApi';
import AddressesList from './AddressesList';
import DeleteAddress from './DeleteAddress';
import EmptyAddresses from "./EmptyAddresses";
import './styles.scss';

function Addresses() {
    const { data } = useAddresses()

    const IS_EMPTY = data && !data.rows.length

    return (
        <>
            <h1 className="addresses-title">Мои адреса</h1>
            {!IS_EMPTY ? <AddressesList /> : <EmptyAddresses />}
            <DeleteAddress />
        </>
    )
}

export default observer(Addresses)
